import React from "react";
import { ReactComponent as EditIcon } from "assets/icons/edit.svg";
import { ReactComponent as CloselIcon } from 'assets/icons/close.svg';
import { ReactComponent as ResizelIcon } from 'assets/icons/resize.svg';
import { StandartButton } from "commons/form-controls";
import s from "./component-header-buttons.module.scss";

const ComponentHeaderButtons = (props) => {

    const clickButton = (type) => {
        props.callback(type, props.index);
    }

    return (
            <div className={s.ReportComponentsHeaderButtons}>
                <div className={s.ReportControlButtons}>
                    {/*<StandartButton icon={EditIcon} background={'var(--background)'} callback={clickButton.bind(this, 'edit')} />*/}
                    <StandartButton icon={ResizelIcon} background={props.draggableIndex == props.index ? '' : 'white'} callback={clickButton.bind(this, 'move')} />
                    <StandartButton icon={CloselIcon} background={'var(--background)'} callback={clickButton.bind(this, 'delete')} />
                    
                </div>
                
            </div>
    )
}

export default ComponentHeaderButtons;